import React from 'react';
import { BadgeProps, Group } from '@landr/maestro';
import { AttributeGroups } from 'types/attributes';
import { useAttributesMapping } from 'hooks/useAttributeMapping/useAttributesMapping';
import { NavigableAttributes } from './components/NavigableAttributes';

export const AttributesBadge = ({
    attributes = {},
    options = {
        kind: 'base',
        isRounded: false,
        size: 'md',
        variant: 'default',
    },
    maxChar = 55,
}: {
    attributes?: AttributeGroups;
    options?: BadgeProps;
    maxChar?: number;
}) => {
    const attributesMapped = useAttributesMapping({ attributes, maxChar });

    return (
        <>
            {attributesMapped?.map(({ code, displayName, kind }) => (
                <Group.Item key={code}>
                    <NavigableAttributes
                        displayName={displayName}
                        code={code}
                        kind={kind}
                        options={options}
                    />
                </Group.Item>
            ))}
        </>
    );
};
